import { MediaTrack } from '@editor/interfaces'

export const getTrackList = (tracks: MediaTrack) => {
  const trackList = `prime-${tracks.prime.toString()}above-${tracks.above.toString()}below-${tracks.below.toString()}`
  return trackList
}
